document.addEventListener('DOMContentLoaded', function () {
  var btn = document.getElementById('js-app-open-or-download');
  if (!btn) return;

  var isIOS      = btn.dataset.ua === 'ios';
  var isAndroid  = btn.dataset.ua === 'android';
  var isMobile   = isIOS || isAndroid;
  var isSignedIn = btn.dataset.signedIn === '1';
  var androidStoreUrl = 'https://play.google.com/store/apps/details?id=com.tunagate.app';

  function scrollToParticipate() {
    var pc = document.getElementById('participate-button2');
    var sp = document.getElementById('participate-button');
    var target = (pc && pc.offsetParent !== null) ? pc : sp;
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  btn.addEventListener('click', function () {
    if (!isMobile) {
      if (isSignedIn) {
        $('#appDownloadQrModal').modal('show');
      } else {
        scrollToParticipate();
      }
      return;
    }

    if (isIOS) {
      if (!isSignedIn) { scrollToParticipate(); return; }
      window.location.href = btn.dataset.universalLinkUrl;
      return;
    }

    // Android: Intent URL でネイティブEventPageへ。アプリなしは signed_in に応じてリダイレクト
    // フォールバック先は現在のオリジンを使う（本番ホスト固定だと dev/staging から
    // 本番へ飛び、存在しないイベントで 404 → 本番トップへ流されてしまう）
    var androidFallbackUrl = isSignedIn
      ? androidStoreUrl
      : window.location.origin + btn.dataset.eventPath + '#participate-button';
    var intentUrl = 'intent://invitation?rurl=' + encodeURIComponent(btn.dataset.eventPath)
      + '#Intent;scheme=tunagate;package=com.tunagate.app'
      + ';S.browser_fallback_url=' + encodeURIComponent(androidFallbackUrl)
      + ';end';
    window.location.href = intentUrl;
  });
});
